
export enum ChatWidget {
    TEMPLATE_HINT_HELLO = 'template_hint_hello',
    TEMPLATE_HINT_PRICE = 'template_hint_price',
    TEMPLATE_HINT_FILL_INFO = 'template_hint_fill_info',
    TEMPLATE_HINT_PAYMENT = 'template_hint_payment',
    TEMPLATE_HINT_SMS = 'template_hint_sms',

    TEMPLATE_HINT_FILL_INFO_TRAVEL = 'template_hint_fill_info_travel',
}